import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * 알람 인박스 "확인 시점".
 *
 * 읽은 id 를 하나씩 쌓지 않고 **마지막으로 알림함을 연 시각** 하나만 들고 있는다.
 * 그 시각보다 새 것이 안 읽은 것이다.
 *
 * id 목록으로 관리하면 새로고침에 약하다. 실시간으로 들어온 알람은 STOMP 버퍼에만
 * 있다가 새로고침에 사라지고, 이력은 대시보드에서 다시 오는데 그 둘의 읽음 상태를
 * 맞추려면 id 를 계속 쌓아야 한다. 시각 하나면 어느 쪽에서 온 것이든 같은 기준으로
 * 걸러진다.
 *
 * 초기값이 `Date.now()` 인 것이 중요하다. 0 으로 두면 **처음 켠 순간 과거 이력 전체가
 * 안 읽음**이 되어 뱃지가 목록 상한(50)에 붙박이로 걸린다. 처음 켠 시점 이전의 일은
 * 이미 지난 일로 본다.
 *
 * 서버에 읽음 API 가 없어 기기 간에 공유되지 않는다 — 생기면 이 스토어만 옮기면 된다.
 */
interface AlarmInboxState {
  lastSeenAt: number;
}

interface AlarmInboxActions {
  /** 알림함을 열었다 — 지금까지 들어온 것은 확인한 것으로 본다. */
  markSeen: () => void;
}

type AlarmInboxStore = AlarmInboxState & AlarmInboxActions;

export const useAlarmInboxStore = create<AlarmInboxStore>()(
  persist(
    (set) => ({
      lastSeenAt: Date.now(),
      markSeen: () => set({ lastSeenAt: Date.now() }),
    }),
    { name: "safers.alarm-inbox" }
  )
);

export const selectLastSeenAt = (s: AlarmInboxStore) => s.lastSeenAt;
export const selectMarkSeen = (s: AlarmInboxStore) => s.markSeen;
